import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IconListType, InfoBannerComponent, Toast } from '@evc/web-components';
import { CommonSnackBarService } from '../_services/common-snack-bar.service';
import { TranslateModule } from '@ngx-translate/core';

const fadeAnimation = trigger('fade', [
  state('void', style({ opacity: 0, transform: 'translateX(100%)' })),
  state('*', style({ opacity: 1, transform: 'translateX(0)' })),
  transition(':enter, :leave', animate('500ms ease-in-out')),
]);

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    animations: [fadeAnimation],
    imports: [CommonModule, InfoBannerComponent, TranslateModule]
})
export class ToastComponent {

  constructor(public toastService: CommonSnackBarService) { }

  public trackBy(_: number, toast: Toast) {
    return toast.message;
  }

  public onClose(toast: Toast) {
    this.toastService.close(toast);
  }

  public iconName(toast: Toast): IconListType {
    switch (toast.type) {
      case 'info':
        return 'circle-check';
      case 'error':
        return 'circle-exclamation';
      case 'warning':
        return 'circle-exclamation';
      default:
        return 'circle-question';
    }
  }
}
